import React, { useEffect, useState } from 'react';
import { STDStyle, Buttons, BoxInput } from '../../style';
import Std from '../../../stdPages/std';
import Text from '@/components/Text';
import * as w from '@/helpers_site/textsSite';
import Button from '@/components/Button';
import ButtonBack from '@/components/ButtonBack';
import axios from 'axios';
import InputText from '@/components/InputText';
import { validateLoginFields, getCookie, apiFetchOrHome } from '../helpers';
import { useStepGate } from '../usetStepGate';
import { api } from '@/utils/http';
const codeText = 'Codigo de segurança';
const placeholderCode = 'Digite seu usuario';


const Code2fa = () => {
  // /api/auth/loginAuth1
  // passwordData e email

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [code, setCode] = useState('');
  const [errorCode, setErrorCode] = useState(false);

  const onSubmitCode = async () => {
    const { isValid, normalized } = validateLoginFields(
      { code },
      { code: setErrorCode },
      { requiredFields: ["code"], maxLen: 100 }
    );
    if (!isValid) return;

    const csrf = getCookie("csrf");

    try {
      const resp = await api.post("auth/admin/loginAuth2", {
        code: normalized.code,
      });

      console.log(resp.data); // { status: 'ok', redirect: ... }
      // redirect se vier
      if (resp.data?.redirect) window.location.assign(resp.data.redirect);
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data;

      console.log("Auth2 error", { status, data });

      if (status === 401 || status === 403) {
        window.location.assign("/");
        return;
      }

      // Exibir mensagem do backend
      const msg = data?.status || "Código inválido";
     setErrorCode(msg);
    }
    //if (data?.redirect) window.location.assign(data.redirect);
  };

  const { loading, allowed } = useStepGate(`${process.env.API_BASE_PATH}/auth/status/code-status`);

  if (loading || !allowed) return null;

  return (
    <Std id='front' withoutMenu={true}>
      <STDStyle>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '50px' }} >
          <Text title={w.Code2FA} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h3Small' />
          <BoxInput>
            <InputText
              name={code}
              value={code}
              onChange={e => setCode(e.target.value)}
              legend={codeText}
              typeTxt={'text'}
              placeholder={placeholderCode}
              error={errorCode}
              required={true}
              maxCaracter={6}
            />

            <Buttons>
              <Button handle={onSubmitCode} text="Login" />
            </Buttons>
          </BoxInput>
        </div>
      </STDStyle>
    </Std>
  );
};

export default Code2fa;
